module.exports = __webpack_public_path__ + "img/multicedi-logo.fb6dadfa.svg";